import React from 'react'

import { bool, node, string } from 'prop-types'

function DetailRow({ label, children, pill = false }) {
  const valueClassName = pill
    ? 'error-banner__error-id cgt-caption-semibold'
    : 'error-banner__error-detail cgt-caption'

  return (
    <div className="error-banner__error-row">
      <span className="error-banner__error cgt-caption-semibold">{label}</span>
      <span className={valueClassName}>{children}</span>
    </div>
  )
}

DetailRow.propTypes = {
  label: string.isRequired,
  children: node.isRequired,
  pill: bool,
}

export default DetailRow
